export enum CounterStyle {
  LocalNonReactive = 'counter__local-non-reactive',
  LocalReactive = 'counter__local-reactive',
  SharedNonReactive = 'counter__shared-non-reactive',
  SharedReactive = 'counter__shared-reactive',
}
